import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['archive', 'archiveAll'];
  static values = { deleteCount: Number };

  connect() {
    this.refresh();
  }

  toggleAll() {
    this.archiveTargets.forEach((checkbox) => {
      checkbox.checked = this.archiveAllTarget.checked;
    });
    this.refresh();
  }

  refresh() {
    const archiveCount = this.archiveTargets.filter((checkbox) => checkbox.checked).length;
    const total = this.deleteCountValue + archiveCount;
    const verbs = [];

    if (this.deleteCountValue > 0) {
      verbs.push('Delete');
    }
    if (archiveCount > 0 || total === 0) {
      verbs.push('Archive');
    }

    this.archiveAllTarget.checked = archiveCount === this.archiveTargets.length;
    this.#submit.disabled = total === 0;
    this.#submit.querySelector('[data-role="label"]').textContent =
      `${verbs.join(' & ')} ${total} Product(s)`;
  }

  get #submit() {
    return [...this.element.elements].find((element) => element.type === 'submit');
  }
}
